module.exports = __webpack_public_path__ + "static/media/manageMySpace.b1fa7c8a.svg";